// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"421a87d5","205":"ff1d83f2","238":"12cc23ae","358":"7c2973ec","530":"4ddc2743","560":"f8fe2a95","596":"c392a290","804":"04bf8e8b"}[chunkId] + ".chunk.js";
};